import React, { useState } from "react";
import "../../style/user/UserSettings.css";

const UserSettings: React.FC = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [notifications, setNotifications] = useState(true);

  const handleSave = () => {
    alert("Settings saved successfully");
  };

  return (
    <div className="settings-container">
      <h2>Settings</h2>

      <div className="settings-card">
        <div className="setting-item">
          <span>Dark Mode</span>
          <input
            type="checkbox"
            checked={darkMode}
            onChange={() => setDarkMode(!darkMode)}
          />
        </div>

        <div className="setting-item">
          <span>Email Notifications</span>
          <input
            type="checkbox"
            checked={notifications}
            onChange={() => setNotifications(!notifications)}
          />
        </div>

        <div className="setting-item">
          <span>Language</span>
          <select  className="otp-input">
            <option value="">Select Language</option>
            <option value="EN">English</option>
          </select>
        </div>

        <button className="save-btn" onClick={handleSave}>
          Save Settings
        </button>
      </div>
    </div>
  );
};

export default UserSettings;
